import { Spacer, VStack } from "@/components/Layout";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { cn } from "@/lib/cn";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { createFileRoute } from "@tanstack/react-router";
import AppProfilePrimaryChart from "./-components/AppProfilePrimaryChartSkeleton";
import RecommendedActions from "./-components/RecommendedActions";
import MonthlyActiveUserCard from "./-components/stat-cards/MonthlyActiveUserCard";
import MonthlyCostCard from "./-components/stat-cards/MonthlyCostCard";
import RenewalDateCard from "./-components/stat-cards/RenewalDateCard";
import SavingCostCard from "./-components/stat-cards/SavingCostCard";
import UsersCard from "./-components/stat-cards/UsersCard";
import { useAppIntegrationContract } from "./-query";

export const Route = createFileRoute("/_staff/app-integrations/$id/_$id/")({
  component: AppIntegrationOverview,
});

function AppIntegrationOverview() {
  const { t } = useTranslation(defaultNS, { keyPrefix: "pages.profile.app" });
  const { id } = Route.useParams();

  const { data: appIntegrationData } = useAppIntegrationContract(id);
  const { integratedApp } = appIntegrationData;

  useDocumentTitle(
    t("pageTitle", {
      name: integratedApp.name,
      interpolation: { escapeValue: false },
    }),
  );
  // TODO: Gridコンポーネントを使用する
  return (
    <VStack className="px-12 py-5">
      <AppIntegrationOverviewCards id={id} />
      <Spacer size={20} />
      <div className="grid grid-cols-[1fr,360px] gap-7">
        <AppProfilePrimaryChart />
        <RecommendedActions />
      </div>
    </VStack>
  );
}

function AppIntegrationOverviewCards({ id }: { id: string }) {
  const { data: appIntegrationData } = useAppIntegrationContract(id);
  const { contract } = appIntegrationData;
  // TODO: Gridコンポーネントを使用する
  return (
    <div
      className={cn(
        "grid gap-5",
        contract.hasPricing ? "grid-cols-5" : "grid-cols-4",
      )}
    >
      {contract.hasPricing && <MonthlyCostCard />}
      <UsersCard />
      <MonthlyActiveUserCard />
      <RenewalDateCard />
      <SavingCostCard />
    </div>
  );
}
